<template>
  <v-dialog scrollable content-class="custom-dialog" ref="dlgKelas" v-model="dialog" retain-focus max-width="760">
    <template v-slot:activator="{}"></template>

    <v-card>
      <!-- HEADER -->
      <v-card-title class="primary white--text d-flex align-center">
        <div class="title font-weight-medium">Informasi Pendaftaran</div>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false" aria-label="Tutup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- BODY -->
      <v-card-text v-if="items.length > 0" class="pt-4 pb-0">
        <div class="text-left black--text pb-2" v-if="jenis.agreement" v-html="jenis.agreement"></div>

        <!-- Keterangan form sesuai kondisi -->
        <v-alert v-if="showCourses && model && model === 'lolos'" type="success" text class="mb-4">
          Selamat! Anda <b>telah tuntas</b> pada tahap <b>{{ prevClass.nama }}</b>.
          <div v-if="items.length > 0" class="mt-1">Silakan memilih jadwal untuk kegiatan berikut.</div>
        </v-alert>

        <v-alert v-else-if="showCourses && model && model === 'ulang'" type="error" text class="mb-4">
          Maaf! Anda <b>tidak tuntas</b> pada tahap <b>{{ prevClass.nama }}</b>.
          <div v-if="items.length > 0" class="mt-1">Silakan memilih jadwal yang tersedia untuk mengulang pelaksanaan kegiatan tersebut.</div>
        </v-alert>

        <v-alert v-else-if="showCourses && model && model === 'pilih' && items.length > 0" type="info" text class="mb-4">
          Anda dapat memilih <b>sesi</b> pelaksanaan di bawah ini berdasarkan waktu luang Anda.
        </v-alert>

        <v-alert v-else-if="showCourses && model && model === 'ubah' && items.length > 0" type="info" text class="mb-4">
          Anda dapat memilih <b>sesi</b> alternatif di bawah ini berdasarkan waktu luang Anda.
        </v-alert>

        <!-- Alert existing -->
        <m-alert
          v-if="this.current_instansi.id == 4"
          show
          info="Untuk saat ini, jadwal angkatan yang bisa Anda pilih adalah 3 jadwal terdekat yang tersedia. Jadwal angkatan lain (total 20 angkatan) akan tersedia mulai H-14 untuk tiap-tiap angkatan"
          closable
        ></m-alert>

        <m-alert
          v-if="isKuotaPenuh"
          icon="mdi-alert"
          color="warning"
          type="warning"
          show
          title="Informasi Kuota Penuh"
          info="Kuota Kelas Angkatan yang Anda pilih sudah penuh. Silakan memilih kelas angkatan lainnya."
          closable
        ></m-alert>

        <!-- FORM -->
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation v-show="showCourses">
          <!-- Hidden input untuk validasi vee-validate (required) -->
          <input
            type="hidden"
            v-model="kelas"
            name="jadwal"
            data-vv-name="jadwal"
            data-vv-as="Jadwal"
            v-validate="'required'"
            data-vv-scope="form"
          />

          <v-alert
            v-if="errors.collect('form.jadwal') && errors.collect('form.jadwal').length"
            type="error"
            dense
            text
            class="mb-3"
          >
            {{ errors.collect('form.jadwal')[0] }}
          </v-alert>

          <!-- GROUP BY TANGGAL (accordion = 1 terbuka) -->
          <v-expansion-panels v-model="openedPanel" accordion class="jadwal-panels">
            <v-expansion-panel
              v-for="(group, gi) in groupedItems"
              :key="'grp-' + gi"
              class="jadwal-panel"
              :class="{ 'jadwal-panel--active': openedPanel === gi }"
            >
              <v-expansion-panel-header class="jadwal-panel-header">
                <div class="d-flex align-center w-100">
                  <v-icon class="mr-2" color="primary">mdi-calendar</v-icon>

                  <div>
                    <div class="subtitle-1 font-weight-medium">{{ group.dateLabel }}</div>
                    <div class="caption grey--text">{{ group.sessions.length }} pilihan sesi</div>
                  </div>

                  <v-spacer></v-spacer>
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row dense>
                  <v-col v-for="item in group.sessions" :key="'item-' + item.id" cols="12" sm="6">
                    <v-card
                      class="jadwal-card"
                      :class="cardClass(item)"
                      :disabled="item.disabled || item.is_disable"
                      outlined
                      @click="pickItem(item)"
                    >
                      <v-card-text class="py-3">
                        <div class="d-flex align-start">
                          <!-- radio indicator -->
                          <div class="mr-3 mt-1">
                            <v-icon
                              :class="kelas === item.id ? 'jadwal-radio-icon--on' : 'jadwal-radio-icon--off'"
                              :color="kelas === item.id ? 'primary' : 'grey'"
                            >
                              {{ kelas === item.id ? "mdi-radiobox-marked" : "mdi-radiobox-blank" }}
                            </v-icon>
                          </div>

                          <div class="flex-grow-1">
                            <div class="d-flex align-center">
                              <v-chip small :color="sessionColor(item)" text-color="white" class="jadwal-sesi-chip">
                                {{ sessionLabel(item) || "SESI" }}
                              </v-chip>
                              <v-spacer></v-spacer>
                            </div>

                            <div v-if="item.disabled" class="caption primary--text text--darken-4 mt-1">
                              Jadwal yang Anda pilih sebelumnya
                            </div>

                            <div class="jadwal-time mt-2">
                              {{ formatTimeRange(item) }}
                            </div>

                            <!-- KUOTA (chip simple & jelas) -->
                            <v-chip
                              small
                              outlined
                              class="jadwal-quota-chip"
                              v-if="item.angkatann"
                            >
                              <v-icon x-small class="mr-1">mdi-account-multiple</v-icon>
                              Kuota {{item.angkatann?formatNumber(item.angkatann.kuota):0}}
                              <span class="mx-1">•</span>
                              Sisa Kuota {{formatNumber(item.angkatann.kuota-item.kelasenrol_count)}}
                            </v-chip>



                            <div class="mt-2">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="jadwal-deadline"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <div class="jadwal-deadline__title">
                                      Batas pendaftaran
                                    </div>
                                    <div class="jadwal-deadline__value">
                                      {{ pVal(item, "tgl_selesai_daftar") | toDT }}
                                    </div>
                                  </div>
                                </template>
                                <span>
      Pendaftaran ditutup pada {{ pVal(item, "tgl_selesai_daftar") | toDT }}
    </span>
                              </v-tooltip>
                            </div>


                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-card-text>

      <!-- EMPTY STATE -->
      <v-card-text v-else>
        <v-row class="mt-2">
          <v-col cols="12" sm="4" class="d-none d-sm-flex">
            <v-img class="img-fluid" src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/modal-informasi.png"></v-img>
          </v-col>
          <v-col cols="12" sm="8">
            <p><strong>Mohon maaf,</strong></p>
            <p v-if="jenis && jenis.is_kuota">
              Kuota belajar untuk <strong>Seri {{ current_instansi.nama }} sudah terpenuhi</strong>. Bapak/Ibu bisa mengikuti program Diklat GTK seri lainnya yang akan tersedia.
              <br />Terima kasih atas antusiasinya mengikuti program Diklat GTK seri {{ current_instansi.nama }}.
            </p>
            <p v-else>Jadwal Kegiatan berikutnya di Seri {{ current_instansi.nama }} belum tersedia.</p>
            <p>Terima kasih atas antusiasinya mengikuti program Diklat GTK seri {{ current_instansi.nama }}.</p>
            <p>Salam Diklat GTK</p>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- FOOTER -->
      <v-card-actions class="pb-4 pt-2">
        <v-row no-gutters>
          <v-col cols="12" v-if="jenis && jenis.agreement">
            <v-checkbox
              v-if="items.length > 0"
              v-model="setuju"
              class="mx-2"
              dense
              color="teal"
              name="setuju"
              label=""
              data-vv-name="setuju"
              data-vv-as="Persetujuan"
              v-validate="'required'"
              :error-messages="errors.collect('form.setuju')"
            >
              <template v-slot:label>
                <div class="body-2 black--text">Dengan ini saya sukarela mengikuti pembelajaran {{ current_instansi.nama }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" align="right">
            <m-button
              class="mx-1"
              color="grey"
              outlined
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Tutup"
              icon=""
              action="tutup"
              @tutup="dialog = false"
            ></m-button>

            <m-button
              v-if="jenis && jenis.agreement"
              class="mx-1"
              :disabled="!setuju"
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Ikuti Pembelajaran"
              icon="mdi-pencil"
              action="pilihKelas"
              @pilihKelas="daftarKelas(false)"
            ></m-button>

            <m-button
              v-else-if="items.length > 0"
              class="mx-1"
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Daftar"
              icon=""
              action="pilihKelas"
              @pilihKelas="daftarKelas()"
            ></m-button>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//@group Global Feature
export default {
  name: "kelas-daftar",
  data() {
    return {
      jenis: null,
      edit: false,
      dialog: false,
      resolve: null,
      reject: null,
      kelas: null,
      kelasObject: null,
      items: [],
      itemKuotaFiltered: [],
      model: null,
      prevClass: null,
      persistent: true,
      lastStep: false,
      lastMissedClass: null,
      showCourses: false,
      idJenis: null,
      setuju: false,
      isKuotaPenuh: false,

      openedPanel: 0
    };
  },
  computed: {
    groupedItems() {
      const groups = new Map();

      (this.items || []).forEach((it) => {
        const dateLabel = this.dateLabel(it);
        if (!groups.has(dateLabel)) groups.set(dateLabel, []);
        groups.get(dateLabel).push(it);
      });

      const toNum = (lbl) => {
        const m = String(lbl || "").match(/SESI\s*(\d+)/i);
        return m ? parseInt(m[1], 10) : 999;
      };

      const result = Array.from(groups.entries()).map(([dateLabel, sessions]) => {
        const sorted = [...sessions].sort((a, b) => {
          const an = toNum(this.sessionLabel(a));
          const bn = toNum(this.sessionLabel(b));
          if (an !== bn) return an - bn;
          return String(this.pVal(a, "angkatan") || "").localeCompare(String(this.pVal(b, "angkatan") || ""));
        });
        return { dateLabel, sessions: sorted };
      });

      return result.sort((a, b) => String(a.dateLabel).localeCompare(String(b.dateLabel)));
    }
  },
  methods: {
    // ====== LOGIC LAMA ======
    open(model, obj, showCourses, idJenis) {
      this.kelas = null;
      this.kelasObject = null;

      this.jenis = obj;
      this.idJenis = idJenis;
      this.showCourses = showCourses;
      this.lastStep = false;
      this.prevClass = obj;
      this.isKuotaPenuh = false;

      this.model = model;
      if (model == "ulang") this.lastStep = true;

      this.$validator.reset();

      return this.loadJadwal(obj, idJenis).then(() => {
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
          this.openedPanel = 0;
          this.dialog = true;
        });
      });
    },

    formatNumber(num) {
      const n = Number(num) || 0;
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    loadJadwal(obj, idJenis) {
      return this.$store
        .dispatch("kelas/getJadwalPerJenis", {
          instansi_id: this.instansi_id,
          jenis_id: idJenis,
          obj: obj
        })
        .then((res) => {
          var tempKelas = [];
          if (this.showCourses) {
            res.forEach((diklat) => {
              diklat.kelas.forEach((kelas) => tempKelas.push(kelas));
            });

            if (this.model == "ubah") {
              // KEEP semua jadwal, tapi disable jadwal yang lama (jenis.id)
              this.items = tempKelas.map(k => ({
                ...k,
                disabled: k.id === this.jenis.id
              }));

              // kalau jadwal lama tidak ikut balik dari API, tetap tampilkan (disabled)
              if (!this.items.find(k => k.id === obj.id)) {
                this.items.push({ ...obj, disabled: true });
              }

              if (this.items.length > 100) this.items = this.items.slice(0, 100);
            } else {
              this.items = [...tempKelas];
              if (this.items.length > 100) this.items = this.items.slice(0, 100);
            }
          } else {
            res.forEach((diklat) => {
              diklat.kelas.forEach((kelas) => tempKelas.push(kelas));
            });
            if (tempKelas.length) this.kelas = tempKelas[0].id;
            return (this.items = [...tempKelas]);
          }
        })
        .catch((e) => e);
    },

    getJadwalTerakhir() {
      return this.$store.dispatch("kelas/missedClass", {}).then((res) => {
        if (res.length > 0) {
          var lastMissedClass = res[res.length - 1];
          this.lastMissedClass =
            "Mohon maaf pendaftaran <strong>" +
            lastMissedClass.nama +
            " Angkatan " +
            lastMissedClass.angkatan +
            "</strong> telah berakhir pada <strong>" +
            this.$options.filters.toD(lastMissedClass.tgl_selesai_daftar) +
            "</strong>";
        } else {
          this.lastMissedClass = null;
        }
      });
    },

    daftarKelas(validasi) {
      this.$validator
        .validateAll("form")
        .then((res) => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          var selected = this.kelasObject;
          if (validasi === false) {
            if (this.model == "ubah") {
              this.$store.commit("main/pStart");
              return this.$store
                .dispatch("kelas/pindahJadwal", { prevJadwal: this.jenis, newJadwal: this.kelasObject })
                .then((res) => {
                  this.$store.commit("main/pEnd");
                  this.$info("Anda berhasil mendaftar di kegiatan " + selected.nama);
                  this.dialog = false;
                  this.edit = false;
                  return this.resolve(res);
                })
                .catch(() => this.$store.commit("main/pEnd"));
            } else {
              this.$store.commit("main/pStart");
              return this.$store
                .dispatch("kelas/enroll", this.kelasObject)
                .then((res) => {
                  this.$store.commit("main/pEnd");
                  this.$info("Anda berhasil mendaftar di kegiatan " + selected.nama);
                  this.dialog = false;
                  this.edit = false;
                  return this.resolve(res);
                })
                .catch(() => {
                  this.loadJadwal({}, this.kelasObject.jenis);
                  this.kelas = null;
                  this.kelasObject = null;
                  this.$validator.reset();
                  this.$store.commit("main/pEnd");
                });
            }
          } else {
            this.$infoDlg(
              `Apakah Anda yakin akan mmengikuti Kegiatan ini??<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${selected.nama}
        </div>
        <br/>
        Jika Anda bersedia meluangkan waktu silakan pilih Ya
        `,
              {},
              "Persetujuan"
            ).then(() => {
              if (this.model == "ubah") {
                this.$store.commit("main/pStart");
                return this.$store
                  .dispatch("kelas/pindahJadwal", { prevJadwal: this.jenis, newJadwal: this.kelasObject })
                  .then((res) => {
                    this.$store.commit("main/pEnd");
                    this.$info("Anda berhasil mendaftar di kegiatan " + selected.nama);
                    this.dialog = false;
                    this.edit = false;
                    return this.resolve(res);
                  })
                  .catch(() => this.$store.commit("main/pEnd"));
              } else {
                this.$store.commit("main/pStart");
                return this.$store
                  .dispatch("kelas/enroll", this.kelasObject)
                  .then((res) => {
                    this.$store.commit("main/pEnd");
                    this.$info("Anda berhasil mendaftar di kegiatan " + selected.nama);
                    this.dialog = false;
                    this.edit = false;
                    return this.resolve(res);
                  })
                  .catch(() => {
                    this.loadJadwal({}, this.kelasObject.jenis);
                    this.kelas = null;
                    this.kelasObject = null;
                    this.$validator.reset();
                    this.$store.commit("main/pEnd");
                  });
              }
            });
          }
        });
    },

    // ====== UI HELPERS ======
    pickItem(item) {
      if (item.disabled || item.is_disable) return;
      this.kelas = item.id;
    },

    parseAsWIB(val) {
      if (!val) return null;
      if (val instanceof Date) return isNaN(val.getTime()) ? null : val;

      let s = String(val).trim();
      const hasTZ = /([zZ]|[+\-]\d{2}:\d{2})$/.test(s);
      s = s.replace(" ", "T");
      if (!hasTZ) s = s + "+07:00";
      const d = new Date(s);
      return isNaN(d.getTime()) ? null : d;
    },

    pad2(n) {
      return String(n).padStart(2, "0");
    },

    tzLabel() {
      const off = new Date().getTimezoneOffset() / 60;
      if (off === -9) return "WIT";
      if (off === -8) return "WITA";
      return "WIB";
    },

    formatHHmm(d) {
      if (!d) return "-";
      return `${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}`;
    },

    formatTimeRange(item) {
      const start = this.parseAsWIB(this.pVal(item, "tanggal_mulai"));
      const end = this.parseAsWIB(this.pVal(item, "tanggal_selesai"));
      return `${this.formatHHmm(start)}–${this.formatHHmm(end)} ${this.tzLabel()}`;
    },

    formatDeadline(item) {
      const d = this.parseAsWIB(this.pVal(item, "tgl_selesai_daftar"));
      if (!d) return "-";
      return `${this.pad2(d.getDate())}-${this.pad2(d.getMonth() + 1)}-${d.getFullYear()} ${this.formatHHmm(d)} ${this.tzLabel()}`;
    },

    sessionLabel(item) {
      const str = String(this.pVal(item, "angkatan") || "");
      const m = str.match(/\(\s*(SESI\s*\d+)\s*\)/i);
      return m ? m[1].toUpperCase() : null;
    },

    dateLabel(item) {
      const str = String(this.pVal(item, "angkatan") || "");
      const base = str.split("(")[0].trim();
      return base || str || "Jadwal";
    },

    sessionColor(item) {
      const s = this.sessionLabel(item);
      return this.sessionColorByLabel(s);
    },

    sessionColorByLabel(label) {
      const l = String(label || "").toUpperCase();
      if (l.includes("SESI 1")) return "indigo";
      if (l.includes("SESI 2")) return "indigo";
      if (l.includes("SESI 3")) return "indigo";
      return "indigo";
    },

    cardClass(item) {
      return {
        "jadwal-card--selected": this.kelas === item.id,
        "jadwal-card--disabled": item.disabled || item.is_disable
      };
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) this.reject(null);
    },
    kelas(n) {
      if (this.items.length > 0) {
        this.items.forEach((kelas) => {
          if (kelas.id == n) this.kelasObject = kelas;
        });
      }
    }
  }
};
</script>

<style scoped>
.custom-dialog {
  -webkit-box-shadow: 0px 0px 2px 2px rgb(231, 230, 230);
}

/* spacing header */
.jadwal-panels >>> .v-expansion-panel-header,
.jadwal-panels /deep/ .v-expansion-panel-header {
  padding-top: 12px;
  padding-bottom: 12px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

/* === INI YANG NENTUIN ABU / PUTIH === */
/* Panel TERTUTUP -> abu */
.jadwal-panels >>> .v-expansion-panel:not(.v-expansion-panel--active),
.jadwal-panels /deep/ .v-expansion-panel:not(.v-expansion-panel--active) {
  background-color: #f5f5f5 !important;
}

/* Header tertutup juga abu */
.jadwal-panels >>> .v-expansion-panel:not(.v-expansion-panel--active) .v-expansion-panel-header,
.jadwal-panels /deep/ .v-expansion-panel:not(.v-expansion-panel--active) .v-expansion-panel-header {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}

/* Panel TERBUKA -> putih */
.jadwal-panels >>> .v-expansion-panel.v-expansion-panel--active,
.jadwal-panels /deep/ .v-expansion-panel.v-expansion-panel--active {
  background-color: #ffffff !important;
}

/* Header TERBUKA -> putih */
.jadwal-panels >>> .v-expansion-panel.v-expansion-panel--active .v-expansion-panel-header,
.jadwal-panels /deep/ .v-expansion-panel.v-expansion-panel--active .v-expansion-panel-header {
  background-color: #ffffff !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* hover (opsional) */
.jadwal-panels >>> .v-expansion-panel-header:hover,
.jadwal-panels /deep/ .v-expansion-panel-header:hover {
  background-color: #eeeeee !important;
}

/* Card */
.jadwal-card {
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease, background 0.12s ease;
}
.jadwal-card:hover {
  transform: translateY(-1px);
}

/* Selected card */
.jadwal-card--selected {
  border-width: 2px !important;
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.14);
  background: rgba(25, 118, 210, 0.04);
}

.jadwal-card--disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.jadwal-radio-icon--on {
  font-size: 22px;
}
.jadwal-radio-icon--off {
  font-size: 22px;
  opacity: 0.9;
}

.jadwal-sesi-chip {
  font-weight: 700;
}
.jadwal-time {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.72);
}
.jadwal-deadline-chip {
  border-color: rgba(255, 152, 0, 0.55);
  color: rgba(255, 152, 0, 0.95);
  background: rgba(255, 152, 0, 0.06);
}
.jadwal-selected-badge {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  color: #1976d2;
}

.jadwal-deadline {
  padding: 6px 8px;
  border-radius: 6px;
  background: #f6f8fa;              /* abu sangat lembut */
  border: 0px solid #e0e0e0;
  font-size: 12px;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.65);
}

.jadwal-deadline__title {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.55);
}

.jadwal-deadline__value {
  margin-top: 2px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.7);
}

.jadwal-quota-chip {
  font-size: 12px;
  font-weight: 500;

  color: #ef6c00; /* orange */
  border-color: rgba(239, 108, 0, 0.45);
  background-color: rgba(255, 152, 0, 0.08);
}

/* kalau card terpilih */
.jadwal-card--selected .jadwal-quota-chip {
  background-color: rgba(255, 152, 0, 0.12);
  border-color: rgba(239, 108, 0, 0.6);
}



</style>
